import { render, staticRenderFns } from "./_articleHandle.vue?vue&type=template&id=7dec8a4c&scoped=true&"
import script from "./_articleHandle.vue?vue&type=script&lang=js&"
export * from "./_articleHandle.vue?vue&type=script&lang=js&"
import style0 from "./_articleHandle.vue?vue&type=style&index=0&id=7dec8a4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dec8a4c",
  null
  
)

export default component.exports